var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"showCounttext",staticClass:"service-process-list"},[_c('div',{staticClass:"content-wrap-box",attrs:{"align":"center"}},[_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":_vm.ossPath + '/pages/home/service-content-info.png',"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5f95c1a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/placeOrder/components/serviceProcess.vue
// module id = null
// module chunks = 